<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="dedit">TO</p>
<p class="dedi"><em class="italic">LEFTY AND NAT</em></p>
<p class="dedi1">FROM</p>
<p class="dedi"><em class="italic">UNCA’ BAY</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedi.vue?b356d7b8